export interface NotificationSkipModel {
  when: SkipNotificationWhen;
  code?: string;
}

export type SkipNotificationWhen = 'never' | 'always' | 'code';
